<template>
  <div class="paypage">
    <!-- 🟩 【银联场景】显示银联标提示文案 -->
    <div v-if="shouldShowTip" class="paypage-tip">
      <div class="paypage-tip-text1">请在标记有</div>
      <div class="paypage-tip-icon"></div>
      <div class="paypage-tip-text2">
        的商家使用
      </div>
    </div>

    <PayCode
      :qr-code="qrCodeInfo.qrCode"
      :selected-card="selectedCard"
      :pay-type-guide="qrCodeInfo.payTypeGuide"
      :is-member-code="isMemberCode"
      :is-meituan-pay-scene="isMeituanPayScene"
      :biz-logo="bizLogo"
      :qr-code-title-icon="qrCodeInfo.qrCodeTitleIcon"
      :tips="qrCodeInfo.tips"
      :qr-code-life="qrCodeInfo.qrCodeLife"
    ></PayCode>

    <!-- 🟩 【会员码模式】显示三方支付渠道 -->
    <div v-if="isMemberCode && qrCodeInfo.guideList && qrCodeInfo.guideList.length" class="payment-channels">
      <div class="payment-channels-title">请选择付款方式</div>
      <div class="payment-channels-list">
        <template v-for="(guide, index) in qrCodeInfo.guideList">
          <!-- 分割线（第一个渠道前不显示） -->
          <div v-if="index > 0" :key="`divider-${index}`" class="channel-divider"></div>
          <!-- 渠道项 -->
          <div
            :key="index"
            class="channel-item"
            @click="goToPayChannel(guide)"
          >
            <div class="channel-item-left">
              <!-- Logo -->
              <div class="channel-item-icon">
                <img :src="guide.icon" :alt="guide.title" />
              </div>
              <!-- 支付方式名称 -->
              <div class="channel-item-name">{{ guide.title }}</div>
              <!-- 营销标签 -->
              <div v-if="guide.promotion" class="channel-item-promotions">
                <div class="channel-item-promotion">
                  {{ guide.promotion }}
                </div>
              </div>
            </div>
            <div class="channel-item-right">
              <!-- type=0或'0': 显示灰色文字+箭头 -->
              <template v-if="guide.type === 0 || guide.type === '0'">
                <div class="channel-item-text">{{ guide.btnTitle }}</div>
                <div class="channel-item-arrow"></div>
              </template>
              <!-- type=1或'1': 显示黄色按钮（无箭头） -->
              <div v-else-if="guide.type === 1 || guide.type === '1'" class="channel-item-btn-yellow">{{ guide.btnTitle }}</div>
              <!-- 其他type: 显示文字+箭头 -->
              <template v-else>
                <div class="channel-item-text">{{ guide.btnTitle }}</div>
                <div class="channel-item-arrow"></div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 付款码模式的原有底部按钮 -->
    <div v-if="!isMemberCode" class="paypage-bottom">
      <div
        v-for="(item, index) in qrCodeInfo.pageBottomButtons"
        :key="index"
        class="paypage-bottom-item"
        @click="jump(item.jumpUrl, item.title)"
      >
        <div class="paypage-bottom-item-left">
          <img class="paypage-bottom-item-left-icon" :src="item.icon" />
          <div class="paypage-bottom-item-left-text">
            {{ item.title }}
          </div>
        </div>
        <div class="paypage-bottom-item-arrow"></div>
      </div>
    </div>
    <div v-if="maskShow" class="mask" @click="showCardList(false)"></div>
    <transition name="cardlist">
      <CardList
        v-if="cardListShow"
        :card-list="qrCodeInfo.userBankcardList"
        :page-action-type="qrCodeInfo.pageActionType"
        :hint="cardListHint"
        :brightness="brightness"
      ></CardList>
    </transition>
  </div>
</template>
<script>
import PayCode from './paycode'
import CardList from './cardlist'
import {
  syncBarCodeOffline,
  sendRaptorErr,
  getSystem,
  paramsInfo,
} from '../utils/util'

export default {
  name: 'PayPage',
  components: {
    PayCode,
    CardList,
    // Card,
  },
  props: {
    qrCodeInfo: {
      type: Object,
      default: () => {},
    },
    brightness: {
      type: Number,
      default: 0.8,
    },
    offlineInfo: {
      type: Object,
      default: () => {},
    },
    getUserQrCodeTimer: {
      type: Number,
      default: 0,
    },
    queryLoop: {
      type: Number,
      default: 1,
    },
    onlyGroup: {
      type: Boolean,
      default: true,
    },
    isMemberCode: {
      type: Boolean,
      default: false,
    },
    isMeituanPayScene: {
      type: Boolean,
      default: false,
    },
    bizLogo: {
      type: String,
      default: '',
    },
    backgroundImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cardListShow: false,
      maskShow: false,
      cardListHint: '',
      queryPayStatusTimerStack: [],
      qrcodeStack: [],
      dialogShow: true,
      dialogTip: '抱歉，暂不能参与本次优惠，点击确认后可继续支付',
      validateInfo: {},
      yodaRetry: true,
      pikeActive: false,
      pikeBzId: '',
      validating: false,
      jumping: false,
      cardChangeValidate: false, //切卡时是否调用继续支付
      channelClickingMap: {}, // 记录每个渠道的点击状态，key为渠道title
    }
  },
  computed: {
    // 判断是否显示银联标提示文案
    // 只有银联场景才显示（非会员码 && 非美团支付场景）
    shouldShowTip() {
      // 会员码不显示
      if (this.isMemberCode) {
        return false
      }
      // 美团支付场景（非银联场景）不显示银联标提示
      // 临时方案：通过 isMeituanPayScene 判断，后期会由后端决策
      if (this.isMeituanPayScene) {
        return false
      }
      // 银联场景显示银联标提示
      return true
    },
    selectedCard() {
      // 会员码模式下或没有银行卡列表时返回空对象
      if (!this.qrCodeInfo.userBankcardList || !this.qrCodeInfo.userBankcardList.length) {
        return {}
      }
      const cardInfo = this.qrCodeInfo.userBankcardList.find((p) => p.isDefault)
      if (!cardInfo) {
        return {}
      }
      return {
        icon: cardInfo.bankLogo,
        text: `${cardInfo.bankcardName}${
          cardInfo.bankcardNo ? `(${cardInfo.bankcardNo})` : ''
        }`,
        labelInfo: cardInfo?.promotion?.labels || [],
        bankcardId: cardInfo.bankcardId,
        promotionDetails: cardInfo?.promotion?.promotionDetails || [],
      }
    },
  },
  watch: {
    'qrCodeInfo.pageBottomButtons': function() {
      this.qrCodeInfo.pageBottomButtons &&
        this.qrCodeInfo.pageBottomButtons.forEach((p) => {
          this.$lx.bottomBtnMV({
            button_name: p.title,
          })
        })
    },
    qrCodeInfo: function() {
      this.pageAction()
    },
  },
  created() {
    this.pageAction()
    console.log('qrCode', this.qrCodeInfo.qrCode)
  },
  mounted() {
    // 页面PV上报，添加type字段
    const type = this.isMemberCode ? '会员码' : '付款码'
    this.$lx.mainPagePV({ custom: { type } })

    this.qrCodeInfo.pageBottomButtons &&
      this.qrCodeInfo.pageBottomButtons.forEach((p) => {
        this.$lx.bottomBtnMV({
          button_name: p.title,
        })
      })

    // 🟩 【新增】三方支付渠道曝光埋点
    this.reportPayChannelView()

    this.$eb.$on('showCardList', this.showCardList)
    this.$eb.$on('closeCardList', this.closeCardList)
    this.$eb.$on('changeCard', this.changeCard)
  },
  beforeDestroy() {
    this.stopInterval()
    this.onlyGroup && this.$bridge.releasePikeClient(this.pikeBzId)
    this.$eb.$off('showCardList')
    this.$eb.$off('closeCardList')
    this.$eb.$off('changeCard')
  },
  methods: {
    pageAction() {
      this.cardListHint = ''
      this.validating = false
      this.jumping = false
      const qrcodeInfo = {
        qrCode: this.qrCodeInfo.qrCode,
        qrCodeId: this.qrCodeInfo.qrCodeId,
      }
      // Pike通道未激活，并且仅在团app上，则初始化Pike
      if (!this.pikeActive && this.onlyGroup) {
        this.createPike()
      }
      switch (this.qrCodeInfo.pageActionType) {
        // 正常被扫页面
        case 0:
          // 绑定支付结果轮询事件
          this.addQuery(qrcodeInfo)
          break
        // 引导用户转签 （绑卡信息待完善）
        case 4:
          // 设置默认的qrCode码
          this.qrCodeInfo.qrCode = '0000000000000000000'
          // 设置提示信息
          this.cardListHint = this.qrCodeInfo.pageActionMsg
          // 弹出支付方式框
          this.showCardList(true)
          break
        // 自定义离线场景，支持支付结果轮询
        case 110:
          this.addQuery(qrcodeInfo)
          break
        default:
          break
      }
    },
    changeCard(index) {
      const cardChangeValidate = this.cardChangeValidate
      this.closeCardList()
      const item = this.qrCodeInfo.userBankcardList[index]
      // 切换默认卡片
      this.$ajax({
        url: '/qrcode/account/changedefaultbankcard',
        data: {
          bankcardId: item.bankcardId,
          qrProductType: 1,
        },
      })
        .then(async () => {
          // 若有验证环节存储的二维码信息，则仅开启特定码的轮询
          if (cardChangeValidate && Object.keys(this.validateInfo).length) {
            await this.validateProcess(this.validateInfo)
            // 结果页返回时触发重新拉码
            this.$bridge.subAppear(this.$eb.$emit('getOnlineQrCode'))
            return
          }
          this.$eb.$emit('getOnlineQrCode')
        })
        .catch(() => {
          this.changeOfflineCard(index)
        })
    },
    changeOfflineCard(index) {
      let start
      try {
        start = Date.now()
        const unionT1 = localStorage.getItem('unionT1') || 0
        const unionT3 = localStorage.getItem('unionT3') || 0
        const { verifyPin: vd, unionpayTime } = this.offlineInfo
        const {
          seed,
          rate,
          fpeKey,
          sessionKey: sk,
          tweak,
        } = this.offlineInfo.bankcardList[index]
        const time = String(
          Math.round(Date.now() / 1000) +
            unionpayTime -
            Math.round((unionT3 - unionT1) / 2) -
            unionT1
        )
        const qrCode = window.GeneratePayCodeModule(
          seed,
          vd,
          fpeKey,
          sk,
          tweak,
          time,
          String(rate)
        )
        this.qrCodeInfo.qrCode = qrCode
        const newList = this.qrCodeInfo.userBankcardList.map((p, _index) => {
          if (_index === index) {
            p.isDefault = true
          } else {
            p.isDefault = false
          }
          return p
        })
        this.$set(this.qrCodeInfo, 'userBankcardList', newList)
        // 上报自定义指标
        const metricInst = window.Owl && window.Owl.MetricManager()
        metricInst &&
          metricInst.setTags({
            type: 'change',
          })
        metricInst && metricInst.setMetric('wasm_success', Date.now() - start)
      } catch (e) {
        console.log(`【离线码切换失败】：耗时${Date.now() - start}ms。${e}`)
        sendRaptorErr('wasm switch fail', e, 'customError')
        // 获取离线二维码code
        const _start = Date.now()
        syncBarCodeOffline(1)
          .then((res) => {
            this.qrCodeInfo.userBankcardList = res.bankCardInfo
            const cacheBankId = this.qrCodeInfo?.userBankcardList[index]
              ?.bankcardId
            // 获取离线二维码code
            syncBarCodeOffline(2, {
              bankCardID: cacheBankId,
            })
              .then((res) => {
                console.log(
                  `【桥模式切换离线码成功】：耗时${Date.now() - _start}ms，${
                    res.payCode
                  }`
                )
                const metricInst = window.Owl && window.Owl.MetricManager()
                metricInst &&
                  metricInst.setTags({
                    type: 'change',
                  })
                metricInst &&
                  metricInst.setMetric('native_success', Date.now() - _start)
                this.qrCodeInfo.qrCode = res.payCode
                this.qrCodeInfo.qrCodeId = 0
                this.qrCodeInfo.userBankcardList[index].isDefault = true
                const newList = this.qrCodeInfo.userBankcardList.map((p) => {
                  p.isEnable = true
                  p.isSign = true
                  return p
                })
                this.$set(this.qrCodeInfo, 'userBankcardList', newList)
              })
              .catch((e) => {
                sendRaptorErr('桥模式切卡失败', e, 'customError')
              })
          })
          .catch((e) => {
            sendRaptorErr('桥模式切卡失败', e, 'customError')
          })
      }
    },
    showCardList(flag) {
      // 待完善场景，关闭半弹窗则直接关闭项目
      if (this.qrCodeInfo.pageActionType === 4 && !flag) {
        this.$bridge.closePage()
        return
      }
      this.cardListShow = flag
      this.maskShow = flag
    },
    closeCardList() {
      this.cardListShow = false
      this.maskShow = false
      this.cardChangeValidate = false
    },
    payFailed(res) {
      this.cardListHint = res.pageActionMsg
      this.qrCodeInfo.userBankcardList = res.userBankcardList
      this.qrCodeInfo.pageActionType = res.pageActionType
      this.showCardList(true)
    },
    jumpToPayResult(res) {
      console.log('onlyGroup', this.onlyGroup)
      // 商企通场景，直接替换页面栈，防止物理键或者返回键回退至付款码页面
      if (!this.onlyGroup) {
        this.$bridge.jumpPage(res.jumpUrl)
        // location.replace(res.jumpUrl)
        return
      }
      // 有额外字段，跳转新版支付结果页
      const { richRewardInfo, tradeNo, mtTransId } = res
      if (richRewardInfo && tradeNo && mtTransId) {
        const value = JSON.stringify({
          richRewardInfo,
          tradeNo,
          mtTransId,
        })
        const url =
          process.env.VUE_APP_PAY_RESULT_URL ||
          'https://npay.meituan.com/resource/pay-result/fullPage.html?callbackUrl=https://awp.meituan.com/payfe/union-pay-qrcode/index.html&notitlebar=1&scene=unionpayqrcode'
        // 存储额外字段至互通存储，并跳转至新版支付成功页
        this.$bridge.setStorage(
          'payResultInfo',
          value,
          0,
          () => {
            this.$lx.paySuccessPageStart(
              {
                custom: { 
                  scene: 'unionpayqrcode',
                  tradeno: tradeNo,
                  timestamp: Date.now(),
                },
              },
              {
                category: 'pay',
              }
            )
            this.$bridge.jumpPage(url, {
              notitlebar: 1,
            })
          },
          () => {
            this.$bridge.jumpPage(url, {
              notitlebar: 1,
            })
          }
        )
      } else {
        this.$bridge.openPage(res.jumpUrl)
      }
    },
    jump(url, button_name) {
      this.$lx.bottomBtnMC({
        button_name,
      })
      this.$bridge.openPage(url)
    },
    // 🟩 【新增】三方支付渠道曝光埋点
    reportPayChannelView() {
      if (!this.isMemberCode || !this.qrCodeInfo.guideList) {
        return
      }

      // 根据isMemberCode判断码类型
      const type = this.isMemberCode ? '会员码' : '付款码'

      this.qrCodeInfo.guideList.forEach((guide) => {
        const params = { type }

        // 根据title上报不同的埋点
        if (guide.title === '美团支付') {
          this.$lx.meituanPayOpenMV(params) // 美团支付开通曝光
        } else if (guide.title === '支付宝付款') {
          this.$lx.alipayMV(params)
        } else if (guide.title === '微信付款') {
          this.$lx.wechatPayMV(params)
        }
      })
    },
    // 🟩 【新增】处理三方支付渠道点击
    goToPayChannel(guide) {
      // 防止连点 - 每个渠道独立控制
      const channelKey = guide.title
      if (this.channelClickingMap[channelKey]) {
        console.log(`⚠️ [PayChannel] ${channelKey} 点击过快，请稍后再试`)
        return
      }

      // 设置当前渠道的点击状态
      this.$set(this.channelClickingMap, channelKey, true)

      try {
        // 根据isMemberCode判断码类型
        const type = this.isMemberCode ? '会员码' : '付款码'
        const params = { type }

        // 根据title上报不同的点击埋点
        if (guide.title === '美团支付') {
          this.$lx.meituanPayOpenMC(params) // 美团支付开通点击
        } else if (guide.title === '支付宝付款') {
          this.$lx.alipayMC(params)
        } else if (guide.title === '微信付款') {
          this.$lx.wechatPayMC(params)
        }

        // 跳转到对应的支付渠道
        if (guide.btnUrl) {
          this.$bridge.openPage(guide.btnUrl)
        }
      } catch (error) {
        console.error(`❌ [PayChannel] ${channelKey} 跳转失败:`, error)
      } finally {
        // 无论成功或失败，1秒后都恢复点击状态
        setTimeout(() => {
          this.$set(this.channelClickingMap, channelKey, false)
        }, 1000)
      }
    },
    createInterval(item, loop) {
      return setInterval(() => {
        this.$ajax({
          url: '/qrcode/app/merchantscan/paystatus',
          data: {
            qrCodeId: item.qrCodeId || 0,
            qrCode: item.qrCode,
          },
        })
        .then((res) => {
            this.handlePaystatus(res, 'polling')
          })
          .catch(() => {})
      }, loop)
    },
    stopInterval() {
      while (this.qrcodeStack.length) {
        this.qrcodeStack.pop()
      }
      while (this.queryPayStatusTimerStack.length) {
        clearInterval(this.queryPayStatusTimerStack.pop())
      }
    },
    addQuery(qrcodeInfo) {
      this.qrcodeStack.unshift(qrcodeInfo)
      this.queryPayStatusTimerStack.unshift(
        // this.createInterval(qrcodeInfo, this.pikeActive ? 5000 : 1000)
        this.createInterval(qrcodeInfo, this.queryLoop * 1000)
      )
      if (this.qrcodeStack.length > 2) {
        this.qrcodeStack.pop()
      }
      if (this.queryPayStatusTimerStack.length > 2) {
        clearInterval(this.queryPayStatusTimerStack.pop())
      }
    },
    yodaCallback(code) {
      // 人脸失败前端降级到短验
      if (code === '430') {
        // 监听Yoda返回结果，并将结果发送至后端，在得到明确失败前，不进行变码操作
        this.$bridge.subCustomAction(
          'union_pay_yoda_cb',
          (data) => {
            // 0代表成功，1代表取消，2代表失败
            switch (data.code) {
              case 1:
                // 用户取消，重新拉码
                this.$eb.$emit('getOnlineQrCode')
                break
              case 2:
                // 人脸失败，降级短验
                this.SMSValidate()
                break
              case 0:
                // 成功
                this.validateInfo.responseCode = data.responseCode
                this.validateProcess(this.validateInfo)
                break
              default:
                break
            }
          },
          () => {
            console.log('subscribe yoda cb success')
          }
        )
        return
      }
      // 其余情况
      this.$bridge.subCustomAction(
        'union_pay_yoda_cb',
        (data) => {
          // 0代表成功，1代表取消，2代表失败
          switch (data.code) {
            case 1:
              // 用户取消，重新拉码
              this.$eb.$emit('getOnlineQrCode')
              break
            case 2:
              // 失败，重新拉码并给予提示
              this.$toast.show({
                type: 'text',
                text: '小主抱歉，由于网络传输的问题可能需要您重新发起支付',
              })
              this.$eb.$emit('getOnlineQrCode')
              break
            case 0:
              // 成功
              this.validateInfo.responseCode = data.responseCode
              this.validateProcess(this.validateInfo)
              break
            default:
              // 默认重新拉码并给予提示
              this.$toast.show({
                type: 'text',
                text: '小主抱歉，由于网络传输的问题可能需要您重新发起支付',
              })
              this.$eb.$emit('getOnlineQrCode')
              break
          }
        },
        () => {
          console.log('subscribe yoda cb success')
        }
      )
    },
    validateProcess(data) {
      // 不含responseCode则不发起继续支付请求
      if (!data.responseCode) {
        return
      }
      return this.$ajax({
        url: '/qrcode/app/merchantscan/extraValidateProcess',
        data,
      })
        .then(() => {
          this.yodaRetry = true
          // 验证成功，继续轮询当前码
          this.addQuery({
            qrCode: data.qrCode,
            qrCodeId: data.qrCodeId,
          })
        })
        .catch((e) => {
          // 继续支付接口超时，继续轮询当前码
          if (e.code === 100000) {
            this.yodaRetry = true
            this.addQuery({
              qrCode: data.qrCode,
              qrCodeId: data.qrCodeId,
            })
            return
          }
          // 重新拉码并给予提示
          this.$toast.show({
            type: 'text',
            text: '小主抱歉，由于网络传输的问题可能需要您重新发起支付',
          })
          this.$eb.$emit('getOnlineQrCode')
        })
    },
    SMSValidate() {
      this.yodaCallback('403')
      // 获取新的requestCode
      this.$ajax({
        url: '/qrcode/yodavalid/authorizeAction',
        data: {
          riskLevel: '4',
          qrCodeId: this.validateInfo.qrCodeId,
          qrCode: this.validateInfo.qrCode,
          action: 'passivescanqrcode',
        },
      })
        .then((res) => {
          // requestCode为空时
          if (!res.requestCode) {
            // 优先重试一次Yoda授权码获取
            if (this.yodaRetry) {
              this.yodaRetry = false
              this.SMSValidate()
              return
            }
            // 若已完成重试，则直接调用继续支付接口，随后轮询
            this.validateProcess(this.validateInfo)
            return
          }
          Object.assign(this.validateInfo, {
            requestCode: res.requestCode,
          })
          // 跳转Yoda
          this.$bridge.openPage(
            `${
              getSystem() === 'android' ? 'yoda' : 'imeituan'
            }://www.meituan.com/verify?requestCode=${
              res.requestCode
            }&action=union_pay_yoda_cb&env=${process.env.VUE_APP_YODA_ENV ||
              '1'}&closeErrorMsg=1&_knbopeninapp=1&openInApp=1`
          )
        })
        .catch((e) => {
          // 获取Yoda授权失败，重新拉码并给予提示
          this.$toast.show({
            type: 'text',
            text: '小主抱歉，由于网络传输的问题可能需要您重新发起支付',
          })
          this.$eb.$emit('getOnlineQrCode')
        })
    },
    createPike() {
      this.pikeBzId = ['production', 'staging'].includes(
        process.env.VUE_APP_ENV
      )
        ? 'qrcode'
        : 'test_qrcode'
      const { uuid } = paramsInfo
      this.$bridge.initPikeClient(
        this.pikeBzId,
        uuid,
        {},
        true,
        this.handlePikeInfo,
        () => {
          this.pikeActive = true
          // 开始接收消息
          this.$bridge.startPikeClient(this.pikeBzId)
          // // 调整当前轮询码间隔为5s
          // const _qrcodeStack = this.qrcodeStack.slice(0)
          // this.stopInterval()
          // _qrcodeStack.forEach((p) => {
          //   this.addQuery(p)
          // })
        }
      )
    },
    handlePikeInfo(info) {
      try {
        const content = JSON.parse(info.messageList[0].content)
        // yoda验证中，只处理当前qrcode对应的pike推送；正在跳转中的时候也停止处理pike信息
        if (
          (this.validating && content.data.qrCode !== this.qrCodeInfo.qrCode) ||
          this.jumping
        ) {
          return
        }
        this.handlePaystatus(content.data, 'pikePush')
      } catch (err) {
        console.log('pike info parse err', err)
      }
    },
    handlePaystatus(res, type) {
      const { qrCode, pageActionType, consumeTime } = res
      // 若码被推送过终态或是Yoda验证，则跳过
      if (
        localStorage.getItem(`${qrCode}-result`) === 1 ||
        (localStorage.getItem(`${qrCode}-yoda`) === 1 && pageActionType === 6)
      ) {
        return
      }
      if ([1, 4].includes(pageActionType)) {
        localStorage.setItem(`${qrCode}-result`, 1)
        if (
          !consumeTime ||
          String(consumeTime).length !== 13 ||
          Date.now() - consumeTime >= 3600000 ||
          Date.now() === consumeTime
        ) {
          sendRaptorErr('支付终态上报异常', res, 'customError', 'info')
        } else {
          const metricInst = window.Owl && window.Owl.MetricManager()
          metricInst &&
            metricInst.setTags({
              type,
            })
          metricInst &&
            metricInst.setMetric('pay_status', Date.now() - consumeTime)
        }
      }
      // 记录yoda验证行为
      if (pageActionType === 6) {
        localStorage.setItem(`${qrCode}-yoda`, 1)
      }
      switch (pageActionType) {
        case 1:
          // 新增跳转中标志
          this.jumping = true
          // 跳转到支付结果页 ：（支付成功or支付失败or交易被限额）
          this.stopInterval()
          // 终止接收Pike推送信息
          this.onlyGroup && this.$bridge.stopPikeClient(this.pikeBzId)
          this.$toast.hide()
          // 隐藏一二维码的放大效果
          this.$eb.$emit('closePreview')
          this.$bridge.subAppear(
            () => {
              this.$eb.$emit('getOnlineQrCode')
              this.onlyGroup && this.$bridge.startPikeClient(this.pikeBzId)
            },
            () => {
              this.jumpToPayResult(res)
            },
            () => {
              this.jumpToPayResult(res)
            }
          )
          break
        case 2:
          // 继续轮询 ：（二维码没有被扫过）
          break
        case 3:
          // 继续轮询 + 显示"支付中Loading"（待支付、支付中、支付成功但未成功通知银联）
          // 隐藏一二维码的放大效果
          this.$eb.$emit('closePreview')
          this.$toast.show({ type: 'pay', text: '支付中' })
          break
        case 4:
          // 页面底部弹出银行卡列表（账户扣款失败）
          this.$bridge.unsubscribeAll()
          clearInterval(this.getUserQrCodeTimer)
          this.stopInterval()
          // 终止接收Pike推送信息
          this.onlyGroup && this.$bridge.stopPikeClient(this.pikeBzId)
          // 隐藏一二维码的放大效果
          this.$eb.$emit('closePreview')
          this.payFailed(res)
          this.$toast.hide()
          break
        case 6:
          this.validating = true
          // 返回状态为待验证
          this.checkValidate(res)
        default:
          break
      }
    },
    checkValidate(res) {
      this.$bridge.unsubscribeAll()
      clearInterval(this.getUserQrCodeTimer)
      this.stopInterval()
      this.$toast.hide()
      const { qrCode, qrCodeId, passiveRiskCode, requestCode } = res
      // 存储当前验证信息
      this.validateInfo = { qrCode, qrCodeId }
      // 当passiveRiskCode为228/649时，弹出银行卡列表并置灰。
      if (['228', '649'].includes(passiveRiskCode)) {
        // 隐藏一二维码的放大效果
        this.$eb.$emit('closePreview')
        this.payFailed(res)
        this.cardChangeValidate = true
        return
      }
      // 当passiveRiskCode（见下方）为403/406/430时，返回requestCode, 并进入对应的yoda验证流程
      if (['403', '406', '430'].includes(passiveRiskCode)) {
        // requestCode为空时
        if (!requestCode) {
          // 优先重试一次进行轮询
          if (this.yodaRetry) {
            this.yodaRetry = false
            this.addQuery(this.validateInfo)
            return
          }
          // 若已完成重试，则直接调用继续支付接口，随后轮询
          this.validateProcess(this.validateInfo)
          return
        }
        this.validateInfo.requestCode = requestCode
        // 隐藏一二维码的放大效果
        this.$eb.$emit('closePreview')
        // 监听Yoda返回结果
        this.yodaCallback(passiveRiskCode)
        const yodaUrl = `${
          getSystem() === 'android' ? 'yoda' : 'imeituan'
        }://www.meituan.com/verify?requestCode=${requestCode}&action=union_pay_yoda_cb&env=${process
          .env.VUE_APP_YODA_ENV ||
          '1'}&closeErrorMsg=1&_knbopeninapp=1&openInApp=1`
        console.log('即将跳转Yoda地址：', yodaUrl)
        // 跳转Yoda
        this.$bridge.openPage(yodaUrl)
      }
    }
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.paypage {
  .size(100%);
  padding: 16px 12px 15px;
  .flex-column-center();
  &-tip {
    .flex-center(center);
    .font-area(14px);
    font-family: PingFangSC-Regular;
    color: rgba(0, 0, 0, 0.7);
    margin-bottom: 10px;
    &-text1 {
      margin-right: 4px;
    }
    &-icon {
      height: 16px;
      width: 25px;
      .bg-img(url('../assets/img/union-icon.png'));
    }
    &-text2 {
      margin-left: 3px;
    }
  }
  &-bottom {
    .flex-column-center();
    margin-top: 9px;
    width: 100%;
    &-item {
      .flex-center(space-between);
      flex-wrap: nowrap;
      gap: 5px;
      width: 100%;
      background: #FFFFFF;
      margin-bottom: 10px;
      border-radius: 20px;
      padding: 0px 22px;
      &-left {
        .flex-center(flex-start);
        width: 100%;
        margin: 22px 0px;
        &-icon {
          .size(22px);
        }
        &-text {
          margin-left: 10px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #111111;
          font-size: 15px;
          line-height: 22px;
          text-align: left;
        }
      }
      &-arrow {
        height: 22px;
        width: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;

        &::after {
          content: '';
          width: 11px;
          height: 11px;
          background-image: url('../assets/img/guide_arrow@3x.png');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
  }
  &-dialog {
    .size(100%);
    .flex-center(center);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 12;
    &-mask {
      .size(100%);
      position: fixed;
      top: 0;
      left: 0;
      background: #000000;
      opacity: 0.76;
    }
    &-body {
      width: 311px;
      background: #ffffff;
      border-radius: 6px;
      z-index: 13;
      position: relative;
      .flex-column-center();
      &-close {
        .size(20px);
        .bg-img(
          url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAplJREFUaAXtmkFuAjEMRRnUq7TXQNyBLuiqG1btccqKDSu6KHdAXKO9SgX1RzPIQCbjJLaFqkSCCZnE/s9ORGaU0aiWGoEagRqBGoEagRqBGoF7jMB+v3/E51605ehppOJ3u90H9X1D/6Zp1sfjcTGdTn+l4zX7kZYH0rAiDa+t3SVpeZf4EAEjkofD4ZsbJIdf5PDFG7qF3ZDvZ65nPB4/TSaTH94Wqo9DjZI2OCToDQRI+mv06YNNsS0CRuQwja8Ne0LHYKFNkl3oFwGjI8EtMI1R58UDegAWS2vBNcXqojXcGRA4Vl/T2j6TgAGuLaALZuhq4SsZ2AvaAhbas4Ctoa1gi4CtoC1hi4G1oa1hVYC1oD1g1YBLob1gVYFzoT1h1YFTob1hTYCl0Cfn9PCBrSnqvGALS+3quzb4yP4f5gJD9YHsbQkIw2bXYy1h4csMGMZj0Lh/Xaxh4c8UGA6k0B6wLsAM+pOm8c0Uxn0qW/rMPd6eiJ+HT7IKvto1G7RA2Q22WzSaA3dTmsT3ZRcvF2YE7fK6yDS0HSwB3fz1hLLnsY7NMjwAuyU4rNuLgsBYZ9oEOAaLLBLlnODmbd0VWn1KD8ES6HkHldL3IioFP1SBcwByxhTw6m08SoSXjE2FV8mwhmANGxL4YmBNoZq2+uCLgC0EWtjk8NnAlsIsbWcBWwrqsmHlIxnYSkgHyq8WvpKALQRwwFBd26cYWNtxCK6vTdO3eC9N+16cqbh56sF+mG8X+0SXtOPFAHxE9t4rqX1RhkNnPODAA5aDxDJtfsbDGxbgsUzzwMTqoindnp9YdoYIFseWzk89XbvHlUGvmb+l9IwHGzNczTkINmw1v8e96cknqSNrBGoEagRqBGoEagT+ZQT+AEJoIildEfrAAAAAAElFTkSuQmCC)
        );
        position: absolute;
        top: 17.4px;
        right: 15.1px;
      }
      &-title {
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-family: PingFangSC-Regular;
        font-size: 17px;
        color: #333333;
        letter-spacing: 0;
      }
      &-split {
        height: 1px;
        width: 100%;
        transform: scaleY(0.5);
        background: #e9e8ea;
      }
      &-tip {
        margin-top: 24.5px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #666666;
        letter-spacing: -0.3px;
        line-height: 12px;
      }
      &-card {
        margin-top: 25px;
        width: 100%;
        padding-left: 15px;
      }
      &-button {
        margin-top: 24px;
        margin-bottom: 15px;
        width: 281px;
        height: 45px;
        background: #ffd100;
        border-radius: 9px;
        text-align: center;
        > span {
          opacity: 0.7;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #000000;
          text-align: center;
          line-height: 45px;
        }
      }
    }
  }
}
.mask {
  .size(100%);
  position: fixed;
  top: 0;
  left: 0;
  background: #000000;
  opacity: 0.76;
  z-index: 12;
}
.cardlist-enter-active {
  animation: cardlist-slide-in 0.3s;
}
.cardlist-leave-active {
  animation: cardlist-slide-out 0.3s;
}

// 🟩 【新增】会员码模式的样式
.payment-channels {
  margin-top: 10px;
  width: 100%;
  padding: 0 22px;

  background: #ffffff;
  border-radius: 20px;
  padding: 20px 22px 2px;

  &-title {
    margin-bottom: 4px;
    color: #111111;
    font-family: PingFang SC, sans-serif;
    font-weight: 500;
    font-size: 17px;
    line-height: 24px;
    text-align: center;
  }

  &-list {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
}

.channel-divider {
  height: 0.5px;
  background: rgba(0, 0, 0, 0.06);
  margin: 0 10px;
}

.channel-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 10px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:active {
    opacity: 0.7;
  }

  &-left {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 20px 0;
  }

  &-icon {
    width: 22px;
    height: 22px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-name {
    color: #111111;
    font-family: PingFang SC, sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    text-align: left;
    white-space: nowrap;
    flex-shrink: 0;
    margin-left: 10px;
  }

  &-promotions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-left: 6px;
  }

  &-promotion {
    border-radius: 3px;
    background: transparent;
    border: 0.5px solid #FFC6C1;
    padding: 0px 4px;
    color: #FF2D19;
    font-family: PingFang SC, sans-serif;
    font-weight: 400;
    font-size: 11px;
    line-height: normal/2;
    text-align: center;
    white-space: nowrap;
    flex-shrink: 0;
  }

  &-right {
    display: flex;
    align-items: center;
    gap: 3px;
    flex-shrink: 0;
  }

  &-text {
    color: #555555;
    font-family: PingFang SC, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    white-space: nowrap;
  }

  &-btn-yellow {
    border-radius: 15px;
    background: #FFDD00;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    padding: 5px 12px;
    color: #111111;
    font-family: PingFang SC, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    white-space: nowrap;
  }

  &-arrow {
    width: 11px;
    height: 11px;
    background-image: url('../assets/img/guide_arrow@3x.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    flex-shrink: 0;
  }
}
</style>
